import React from "react";

export type OpenMapIconProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 15,
    height: 15,
  },
  medium: {
    width: 24,
    height: 24,
  },
  large: {
    width: 36,
    height: 36,
  },
};

export const OpenMapIcon: JSX.Element & any = React.forwardRef<
  SVGSVGElement,
  OpenMapIconProps
>((props, ref) => {
  const { size = "medium", width, height, color = "white" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];

  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.25 0.75V20.25"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.75 3.75V23.25"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M0.75 23.25V3.75L8.25 0.75L15.75 3.75L23.25 0.75V20.25L15.75 23.25L8.25 20.25L0.75 23.25Z"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
});

OpenMapIcon.displayName = "OpenMapIcon";
